import React from "react";
import ReactDOM from "react-dom/client";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

import App from "./App";
import "./index.css";
import "./styles/global.css";
import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";

L.Icon.Default.mergeOptions({
  iconUrl: icon,
  shadowUrl: iconShadow,
});

const openNativeDatePicker = (event) => {
  const input = event.target?.closest?.('input[type="date"]');

  if (!input || input.disabled || input.readOnly) return;

  input.focus();

  try {
    input.showPicker?.();
  } catch {
    // Some browsers only allow showPicker during specific trusted user gestures.
  }
};

document.addEventListener("click", openNativeDatePicker, true);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <App />
    </>
  </React.StrictMode>
);
